/* eslint-disable import/extensions */
import React, { Component } from 'react';
import { StyledButton, StyledGroup, StyledMainWrapper, StyledMenuWrapper, StyledTitle } from '../styled/nbisNavigationMenu.styled';
import { NbisNavigationMenuItems } from './NbisNavigationMenu';

export interface NbisMenuItemsProps {
  depthLevel?: number,
  items?: NbisNavigationMenuItems,
  id?: string | 'menuItems',
  onClick?: React.MouseEventHandler<HTMLLIElement>,
  onSubMenuClick?(e: number): void,
}

class NbisMenuItems extends Component<NbisMenuItemsProps, {}, any> {
  state = {
    dropdown: false,
    menuPosition: 'bottom',
    maxHeight: 0,
  };

  /* istanbul ignore next */
  componentDidMount() {
    let btn = Array.from(document.querySelectorAll('.dropdown-submenu > li > button'));
    btn.forEach((item) => {
      item.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    });
  }

  componentDidUpdate(prevProps: NbisMenuItemsProps, prevState: { dropdown: boolean }) {
    if (prevState.dropdown !== this.state.dropdown && this.state.dropdown) {
      const menuElement = document.getElementById(`${this.props.id}-${(this.props.depthLevel ?? 0) + 1}` || 'menuItems') as HTMLElement;
      const newMaxHeight = this.calculateMaxHeight(this.props.items || { submenu: [] });
      const newMenuPosition = this.calculateMenuPosition(menuElement, newMaxHeight);
      this.setState({ menuPosition: newMenuPosition, maxHeight: newMaxHeight });
    }
  }

  calculateMenuPosition = (menuElement: HTMLElement, maxHeight: number) => {
    if (menuElement) {
      const rect = menuElement.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const viewportWidth = window.innerWidth;
      const menuHeight = maxHeight;
      const menuWidth = menuElement.offsetWidth;

      // Check if the menu will overflow the bottom of the viewport
      const bottomOverflow = rect.bottom + menuHeight > viewportHeight;
      // Check if the menu will overflow the top of the viewport
      const topOverflow = rect.top - menuHeight < 0;

      // If both top and bottom overflow, calculate the best position
      if (bottomOverflow && topOverflow) {
        const availableSpaceBottom = viewportHeight - rect.bottom;
        const availableSpaceTop = rect.top;

        // Calculate the number of items that can fit in each space
        const itemHeight = menuElement.scrollHeight / (this.props.items?.submenu?.length || 1);
        const itemsFitBottom = Math.floor(availableSpaceBottom / itemHeight);
        const itemsFitTop = Math.floor(availableSpaceTop / itemHeight);

        // If both spaces are insufficient, display as much as possible in the larger space
        if (itemsFitBottom > itemsFitTop) {
          return 'bottom';
        } else {
          return 'top';
        }
      }

      // If only bottom overflows, position at the top
      if (bottomOverflow) {
        return 'top';
      }
      // If only top overflows, position at the bottom
      if (topOverflow) {
        return 'bottom';
      }
      // Check if the menu will overflow the right of the viewport
      if (rect.right + menuWidth > viewportWidth) {
        return 'left';
      }
    }
    return 'bottom';
  };

  calculateMaxHeight = (items: NbisNavigationMenuItems) => {
    const menuElement = document.getElementById(`${this.props.id}-${(this.props.depthLevel ?? 0) + 1}` || 'menuItems') as HTMLElement;
    if (menuElement) {
      const submenuHeight = menuElement.scrollHeight;

      const maxHeightMultiplier = this.props.depthLevel && this.props.depthLevel >= 2 ? 0.6 : 0.8;
      const calculatedHeight = window.innerHeight * maxHeightMultiplier;

      // If the calculated height is less than the submenu height, return the submenu height
      if (calculatedHeight < submenuHeight) {
        return submenuHeight;
      }

      return Math.min(submenuHeight, calculatedHeight) + 20; // 增加20px
    }
    return 0;
  };

  handleDropdown = (dropdown: boolean) => {
    const menuElement = document.getElementById(`${this.props.id}-${(this.props.depthLevel ?? 0) + 1}` || 'menuItems') as HTMLElement;
    const newMaxHeight = this.calculateMaxHeight(this.props.items || { submenu: [] });
    const newMenuPosition = this.calculateMenuPosition(menuElement, newMaxHeight);
    this.setState({ dropdown, menuPosition: newMenuPosition, maxHeight: newMaxHeight });
  };

  render() {
    const { dropdown, menuPosition, maxHeight } = this.state;
    let { depthLevel = 0, items, id = 'menuItems', onClick, onSubMenuClick } = this.props;
    depthLevel = depthLevel + 1;
    id = `${id}-${depthLevel}`;
    const dropdownClass = depthLevel > 0 ? 'dropdown-submenu' : '';

    return (
      <>
        {items?.type === 'Group' && <StyledGroup>{items?.title}</StyledGroup>}
        {items?.title && !(items?.type === 'Group') && <StyledMainWrapper className="menu-items" onClick={onClick}>
          {items?.submenu ? (
            <>
              <StyledButton type="button" className={`${dropdown ? 'isActive' : ''}`} aria-expanded={dropdown ? 'true' : 'false'} onMouseOver={() => this.handleDropdown(true)} onMouseOut={() => this.handleDropdown(false)}>
                {items?.title}{' '}
              </StyledButton>
              <StyledMenuWrapper className={`dropdown ${dropdownClass} ${dropdown ? 'show' : ''}`} id={id} style={{ maxHeight: `${maxHeight}px`, top: menuPosition === 'top' ? 'auto' : '0', bottom: menuPosition === 'top' ? '0' : 'auto' }} onMouseOver={() => this.handleDropdown(true)} onMouseOut={() => this.handleDropdown(false)}>
                {items?.submenu.map((submenu, index) => (
                  (submenu.command && !(submenu.submenu) ?
                    <NbisMenuItems items={submenu} id={`subMenuItems-${id}`} key={index} depthLevel={depthLevel} onClick={() => { submenu.command(submenu); this.setState({ dropdown: false }, () => onSubMenuClick && onSubMenuClick(depthLevel)); }} />
                    :
                    <NbisMenuItems items={submenu} id={`subMenuItems-${id}`} key={index} depthLevel={depthLevel} onClick={() => onSubMenuClick && onSubMenuClick(depthLevel)} />)
                ))}
              </StyledMenuWrapper>
            </>
          ) : (<StyledTitle>{items?.title}</StyledTitle>)}
        </StyledMainWrapper>
        }
        {items?.separator && <StyledMainWrapper className={items?.separator ? 'separator' : ''} />}
      </>
    );
  }
}

export default NbisMenuItems;